import { useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import GameMenu from "../components/GameMenu";
import Timer from "../components/Timer";
import Popup from "../components/Popup";
import LeaveGamePopup from "../components/LeaveGamePopup";
import GameWrapper from "../components/GameCountdown";
// import EndGameBtn from "../components/EndGameBtn";
import vinyleLogo from "../assets/images/sidebar/profile-pic-settings.svg"
import "../assets/css/vinyleQCM.css";

export default function VinyleQCM() {
  const [gameStarted, setGameStarted] = useState(false);

  const location = useLocation();
  const { theme, subTheme } = location.state || {};

  const [timerIsFinished, setTimerIsFinished] = useState(false);
  const [timeElapsed, setTimeElapsed] = useState(0);
  const [leaveGamePopup, setLeaveGamePopup] = useState(false);

  const getTimerTimeRef = useRef(null);

  // Questions (à changer pour récupérer en base de données)
  const questions = [
    {
      question: "Quelle est la capitale de l'Australie ?",
      options: ["Sydney", "Melbourne", "Canberra", "Brisbane"],
      correctAnswer: "Canberra",
    },
    {
      question: "Combien font 3 x 4 ?",
      options: ["7", "12", "15", "18"],
      correctAnswer: "12",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [score, setScore] = useState(0);
  const [finished, setFinished] = useState(false);

  const currentQuestion = questions[currentIndex];

  // Récupérer le temps envoyé par Timer
  const sendTime = (time) => {
    setTimeElapsed(time);
  };

  const sendLeaveGame = (value) => {
    setLeaveGamePopup(value);
  };

  // Logique du jeu au clic sur une réponse
  const handleAnswerClick = (answer) => {
    if (!selectedAnswer) {
      setSelectedAnswer(answer);
      if (answer === currentQuestion.correctAnswer) {
        setScore((prev) => prev + 1);
      }
    }
  };

  const nextQuestion = () => {
    if (currentIndex + 1 < questions.length) {
      setCurrentIndex((prev) => prev + 1);
      setSelectedAnswer(null);
    } else {
      endGame();
    }
  };

  // CSS appliqué en fonction des réponses
  const getButtonClass = (answer) => {
    if (!selectedAnswer) return "";
    if (answer === currentQuestion.correctAnswer) return "correct";
    if (answer === selectedAnswer) return "wrong";
    return "";
  };

  const endGame = () => {
    if (getTimerTimeRef.current) {
      const currentTime = getTimerTimeRef.current();
      sendTime(currentTime);
    }
    setFinished(true);
    setTimerIsFinished(true);
  };

  return (
    <div className="page-container">
      <Sidebar />

      <GameWrapper onStart={() => setGameStarted(true)}>
        <div className="content-container inGame" id="vinyleQCM">
          <div className="title">
            <h4>{theme} - {subTheme}</h4>
            <div className="level-infos">
              <Timer
                timer={timerIsFinished}
                onFinish={() => endGame()}
                onSendTime={sendTime}
                onGetTime={(getTimeFn) => (getTimerTimeRef.current = getTimeFn)}
                hasLimit={true}
                limit={120} 
              />
            </div>
          </div>

          {/* <img class="vinyle-logo" src={vinyleLogo} /> */}
          <div className="game-container launched">
            {!finished ? (
              <>
                {/* <div className="vinyle-top"> */}
                  <div className="vinyle-info">
                    <div className="vinyle-length">
                      <p>
                        Question {currentIndex + 1}/{questions.length}
                      </p>
                      <div className="progress-bar">
                        <div
                          className="progress-fill"
                          style={{
                            width: `${((currentIndex + 1) / questions.length) * 100}%`,
                          }}
                        ></div>
                      </div>
                    </div>
                    <h3 className="vinyle-score">
                      Score : {score}/{questions.length}
                    </h3>
                  </div>
                  <div className="vinyle-QR">
                    <h2 className="vinyle-question">{currentQuestion.question}</h2>
                    <h3 className="vinyle-rules">Cliquez sur une réponse pour la valider.</h3>
                  </div>
                {/* </div> */}
                <div className="vinyle-options">
                  {currentQuestion.options.map((answer, index) => (
                    <button
                      key={index}
                      className={`vinyle-button ${getButtonClass(answer)}`}
                      onClick={() => handleAnswerClick(answer)}
                      disabled={!!selectedAnswer}
                    >
                      {answer}
                    </button>
                  ))}
                </div>

                {selectedAnswer && (
                  <button className="vinyle-next" onClick={nextQuestion}>
                    {currentIndex + 1 < questions.length
                      ? "Question suivante"
                      : "Terminer"}
                  </button>
                )}
              </>
            ) : (
              <h3 className="vinyle-score">
                Score : {score}/{questions.length}
              </h3>
            )}
          </div>

          {/* <EndGameBtn onClick={endGame} /> */}
        </div>
      </GameWrapper>

      <GameMenu onSendLeaveGame={sendLeaveGame} />
      <Popup
        time={timeElapsed}
        timerIsFinished={timerIsFinished}
        errorCount={questions.length - score}
      />
      <LeaveGamePopup
        popupOpen={leaveGamePopup}
        onSendLeaveGame={sendLeaveGame}
      />
    </div>
  );
}
